import {Optional} from '@logistics-frontend/types'
import {applySpec, flow, get, map} from '@logistics-frontend/utils'

import {EstimationResult, Offer, OffersCalculateResponse} from 'src/shared/types'

const toOffer: (offer: EstimationResult) => Offer = applySpec<Offer>({
  id: get('payload'),
  currency: get('price.currency'),
  price: get('price.total_price_with_vat'),
  surgeRatio: get('price.surge_ratio'),
  title: get('price.title'),
  tariff: get('price.tariff'),
  vertical: get('price.vertical'),
  visitingIntervals: get('visiting_intervals'),
  disableReason: get('filter_reason.message'),
})

export const toOffers: (offers: Optional<OffersCalculateResponse>) => Array<Offer> = flow(
  get('claims_offers'),
  map(toOffer),
)
